import classic from 'ember-classic-decorator';

import ApplicationSerializer from './application';

@classic
export default class SocialProfileSerializer extends ApplicationSerializer {
  attrs = {
    instagramAccountType: 'account_type'
  };

  serialize(snapshot, options) {
    const serializedProfile = super.serialize(snapshot, options);
    const socialAuthFlowId = snapshot.adapterOptions?.socialAuthFlowId;

    if (socialAuthFlowId) {
      serializedProfile.flow_id = socialAuthFlowId;
    }

    return serializedProfile;
  }
}
